/* Bisous & Co — cadeaux BFCM en dollars (07/10/2026).
   Config : window.BSGiftsConfig (snippets/bfcm-gift-config.liquid).

   La regle, appliquee a chaque changement du panier, au chargement et avant le checkout :
     sous-total payant >= palier 1  → 1 Mystery Gift (quantite 1), sinon aucun
     sous-total payant >= palier 2  → 1 Card Holder offert (couleur choisie), sinon aucun
     cadeaux eteints                → aucun cadeau
   Sous-total payant = somme des final_line_price hors cadeaux et hors cartes cadeaux :
   apres le BOGO (remise produit, deja dans la ligne), avant un code de commande.
   La cliente peut retirer un cadeau : il ne revient pas tout seul pendant la session
   (bouton « Add my free Mystery Gift » dans la barre pour le reprendre).
   Nos propres mises a jour du panier n'ouvrent pas le tiroir s'il est ferme. */
(function () {
  if (window.BSGifts) return;

  var DKEY = 'bs_gift_declined';
  var CKEY = 'bs_gift_color';
  var busy = false;
  var pending = false;
  var rounds = 0;
  var lastToken = '';
  var timer = 0;

  function cfg() { return window.BSGiftsConfig || null; }

  function store(kind) {
    try { return kind === 'local' ? window.localStorage : window.sessionStorage; } catch (e) { return null; }
  }
  function readDeclined(token) {
    var s = store('session'); if (!s) return {};
    try {
      var d = JSON.parse(s.getItem(DKEY) || '{}');
      return d.t === token ? d : {};
    } catch (e) { return {}; }
  }
  function setDeclined(kind, on) {
    var s = store('session'); if (!s || !lastToken) return;
    var d = readDeclined(lastToken); d.t = lastToken;
    if (on) d[kind] = 1; else delete d[kind];
    try { s.setItem(DKEY, JSON.stringify(d)); } catch (e) {}
  }
  function preferredColor() {
    var s = store('session'); if (!s) return 0;
    try { return parseInt(s.getItem(CKEY) || '0', 10) || 0; } catch (e) { return 0; }
  }
  function setPreferredColor(id) {
    var s = store('session'); if (!s) return;
    try { s.setItem(CKEY, String(id)); } catch (e) {}
  }

  function sectionIds() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (el) { return el.dataset.sectionId; }).filter(Boolean);
  }
  function withSections(body) {
    var ids = sectionIds();
    if (ids.length) { body.sections = ids; body.sections_url = location.pathname; }
    return body;
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { lastToken = cart.token || lastToken; return cart; });
  }

  /* Rejoue cart:update avec les sections deja rendues. Le tiroir s'ouvre a chaque
     cart:update quand il porte auto-open : on retire l'attribut le temps de l'evenement
     si le tiroir est ferme, pour qu'un cadeau ajoute ou retire ne l'ouvre pas tout seul. */
  function announce(sections, cart, open) {
    var drawer = document.querySelector('cart-drawer-component');
    var dialog = drawer && drawer.querySelector('dialog');
    var hold = !open && drawer && drawer.hasAttribute('auto-open') && !(dialog && dialog.open);
    if (hold) drawer.removeAttribute('auto-open');
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: 'bfcm-gifts', data: { sections: sections || {}, itemCount: cart.item_count } }
    }));
    if (hold) drawer.setAttribute('auto-open', '');
  }

  function read(cart, c) {
    var out = { paid: 0, myst: [], ch: [] };
    var chIds = (c.cardholder.variants || []).map(function (v) { return v.id; });
    (cart.items || []).forEach(function (it) {
      if (it.product_id === c.mystery.product || it.variant_id === c.mystery.variant) out.myst.push(it);
      else if (it.product_id === c.cardholder.product || chIds.indexOf(it.variant_id) !== -1) out.ch.push(it);
      else if (it.gift_card) return;
      else out.paid += it.final_line_price;
    });
    return out;
  }

  function chDefault(c) {
    var vs = (c.cardholder.variants || []).filter(function (v) { return v.available !== false; });
    var pref = preferredColor();
    var hit = vs.filter(function (v) { return v.id === pref; })[0];
    return (hit || vs[0] || {}).id || 0;
  }

  /* Ce qu'il faut changer : {updates: {key: qty}, adds: [...]}, ou null si rien. */
  function plan(cart, c) {
    var r = read(cart, c);
    var dec = readDeclined(cart.token);
    var updates = {}, adds = [], dirty = false;

    function keepOne(lines, want) {
      lines.forEach(function (it, i) {
        var q = (want && i === 0) ? 1 : 0;
        if (it.quantity !== q) { updates[it.key] = q; dirty = true; }
      });
      return want && lines.length > 0;
    }

    var paidOk = r.paid > 0;
    var wantMyst = c.enabled && paidOk && r.paid >= c.t1 && !dec.mystery;
    var wantCh = c.enabled && paidOk && r.paid >= c.t2 && !dec.cardholder;

    if (!keepOne(r.myst, wantMyst) && wantMyst && c.mystery.variant) {
      adds.push({ id: c.mystery.variant, quantity: 1, properties: { _gift: 'mystery' } });
      dirty = true;
    }
    if (!keepOne(r.ch, wantCh) && wantCh) {
      var id = chDefault(c);
      if (id) { adds.push({ id: id, quantity: 1, properties: { _gift: 'cardholder' } }); dirty = true; }
    }
    return dirty ? { updates: updates, adds: adds } : null;
  }

  function apply(p, open) {
    var chain = Promise.resolve(null);
    var sections = null;
    if (Object.keys(p.updates).length) {
      chain = chain.then(function () {
        return post('/cart/update.js', withSections({ updates: p.updates }))
          .then(function (res) { sections = res.sections || sections; });
      });
    }
    if (p.adds.length) {
      chain = chain.then(function () {
        return post('/cart/add.js', withSections({ items: p.adds }))
          .then(function (res) { sections = res.sections || sections; });
      });
    }
    return chain.then(getCart).then(function (cart) { announce(sections, cart, open); return cart; });
  }

  /* Une passe : relit le panier, corrige, recommence tant qu'il reste quelque chose
     a corriger (3 tours au plus, garde-fou contre une boucle). */
  function sync(opts) {
    opts = opts || {};
    var c = cfg();
    if (!c) return Promise.resolve();
    if (busy) { pending = true; return Promise.resolve(); }
    busy = true;
    rounds = 0;
    function step(cart) {
      var p = plan(cart, c);
      if (!p || rounds >= 3) return cart;
      rounds += 1;
      return apply(p, opts.open).then(step);
    }
    var start = opts.cart && opts.cart.items ? Promise.resolve(opts.cart) : getCart();
    return start.then(function (cart) {
      if (cart && cart.token) lastToken = cart.token;
      if (opts.announce && !plan(cart, c)) {
        /* rien a corriger, mais l'appelant veut que le tiroir se redessine */
        return fetch(location.pathname + '?sections=' + sectionIds().join(','), { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return {}; })
          .then(function (sections) { announce(sections, cart, opts.open); return cart; });
      }
      return step(cart);
    })
      .catch(function (err) { console.warn('[bfcm-gifts]', err); })
      .then(function (cart) {
        busy = false;
        if (pending) { pending = false; schedule(); }
        return cart;
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { sync(); }, 120);
  }

  /* La cliente retire un cadeau avec la poubelle du panier : on note son choix. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.cart-items__remove') : null;
    if (!btn) return;
    var row = btn.closest('[data-bsg-line]');
    if (row) setDeclined(row.getAttribute('data-bsg-line'), true);
  }, true);

  /* « Add my free Mystery Gift » : elle revient sur son choix. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-bsg-readd]') : null;
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    getCart().then(function () {
      setDeclined(btn.getAttribute('data-bsg-readd'), false);
      return sync({ open: true });
    });
  }, true);

  /* Changement de couleur du Card Holder offert (ou ajout, si elle l'avait retire). */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-bsg-swap]') : null;
    if (!btn) return;
    e.preventDefault();
    var c = cfg(); if (!c || busy) return;
    var id = parseInt(btn.getAttribute('data-bsg-swap'), 10);
    if (!id) return;
    btn.setAttribute('aria-busy', 'true');
    setPreferredColor(id);
    busy = true;
    getCart().then(function (cart) {
      setDeclined('cardholder', false);
      var r = read(cart, c);
      var updates = {};
      var same = false;
      r.ch.forEach(function (it, i) {
        if (i === 0 && it.variant_id === id) { same = true; if (it.quantity !== 1) updates[it.key] = 1; }
        else updates[it.key] = 0;
      });
      var p = { updates: updates, adds: same ? [] : [{ id: id, quantity: 1, properties: { _gift: 'cardholder' } }] };
      if (!Object.keys(updates).length && !p.adds.length) return cart;
      return apply(p, true);
    })
      .catch(function (err) { console.warn('[bfcm-gifts]', err); })
      .then(function () { busy = false; btn.removeAttribute('aria-busy'); schedule(); });
  }, true);

  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.sourceId === 'bfcm-gifts') return;
    schedule();
  });

  window.BSGifts = {
    sync: sync,
    /* avant le checkout : le panier doit etre juste, quoi qu'il arrive */
    guard: function () {
      return sync().then(function () { return getCart(); }).then(function (cart) {
        var c = cfg();
        if (c && plan(cart, c)) return sync();
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(); });
  else sync();
})();
